import actions from "./actions";

export default {
  actions,
  state: {
    backstageToken: "",
    adminLevel: "",
    currentOrderInfo: {
      status: "0",
      page: "1",
      keyword: "",
      dateFrom: "",
      dateTo: ""
    }
  },
  mutations: {
    setBackstageToken(state, token) {
      state.backstageToken = token;
    },
    deleteBackstageToken(state) {
      state.backstageToken = "";
    },
    setAdminLevel(state, level) {
      state.adminLevel = level;
    },
    //後台訂單首頁
    updateCurrentOrderStatus(state, status) {
      state.currentOrderInfo.status = status;
    },
    updateCurrentOrderPage(state, page) {
      state.currentOrderInfo.page = page;
    },
    updateCurrentOrderKeyword(state, keyword) {
      state.currentOrderInfo.keyword = keyword;
    },
    updateCurrentOrderDate(state, date) {
      state.currentOrderInfo.dateFrom = date.from;
      state.currentOrderInfo.dateTo = date.to;
    },
    updateCurrentOrderDateFrom(state, date) {
      state.currentOrderInfo.dateFrom = date;
    },
    updateCurrentOrderDateTo(state, date) {
      state.currentOrderInfo.dateTo = date;
    }
  },
  getters: {
    getBackstageToken(state) {
      return state.backstageToken;
    },
    getAdminLevel(state) {
      return state.adminLevel;
    },
    getCurrentOrderStatus({ currentOrderInfo }) {
      return currentOrderInfo.status;
    },
    getCurrentOrderPage({ currentOrderInfo }) {
      return currentOrderInfo.page;
    },
    getCurrentOrderKeyword({ currentOrderInfo }) {
      return currentOrderInfo.keyword;
    },
    getCurrentOrderDateFrom({ currentOrderInfo }) {
      return currentOrderInfo.dateFrom;
    },
    getCurrentOrderDateTo({ currentOrderInfo }) {
      return currentOrderInfo.dateTo;
    }
  }
};
